// Pairs with the custom-scrollbar mixin. Bundled into each showroom script, so
// the window flag below keeps it to one listener per page.

const HIDE_DELAY = 800;
const timers = new WeakMap();

function handleScroll(event) {
  const el = event.target;
  if (!(el instanceof Element)) return;

  el.setAttribute("data-scrolling", "");
  window.clearTimeout(timers.get(el));
  timers.set(
    el,
    window.setTimeout(() => el.removeAttribute("data-scrolling"), HIDE_DELAY),
  );
}

if (!window.showroomScrollbarListening) {
  window.showroomScrollbarListening = true;
  // Scroll events don't bubble, so listen in the capture phase.
  document.addEventListener("scroll", handleScroll, { capture: true, passive: true });
}
